type ClassName = string | undefined | false;
export const mergeClassNames = (...classNames: ClassName[]) => {
  return classNames
    .filter((x) => !!x)
    .join(" ")
    .trim();
};
export const mcn = mergeClassNames;
